import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Divider, Grid, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
import Global from '../../../customlib/Global';
class SoldProductCategoryMobile extends Component {
    state = { } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Sold Product Category"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}></Filter>
                    {/* <Grid container spacing={1}>
                        <Grid item xs={6} textAlign={"center"}><strong>Total Acquisition</strong></Grid>
                        <Grid item xs={6} textAlign={"center"}><strong>Total Retention</strong></Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={6} textAlign={"center"} sx={{fontSize: "20px"}}>{this.props.totalAllAcquisition}</Grid>
                        <Grid item xs={6} textAlign={"center"} sx={{fontSize: "20px"}}>{this.props.totalAllRetention}</Grid>
                    </Grid> */}
                    <Typography variant='h5' component={"div"}>
                        Sold Categories
                    </Typography>
                    {
                    this.props.contactLeadsDisplay?.map((leadGroup, index) => {
                        return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <Typography variant='h6' component="span">{leadGroup.product_category}</Typography>
                                        </Grid>
                                        <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                            <Typography variant='h6' component="span">
                                                CR : {leadGroup.count_product_category > 0 ? (leadGroup.totalClosing/leadGroup.count_product_category*100).toFixed(2).replace(".00", "") : 0}%
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} textAlign={"left"} sx={{pr: "5px"}}>
                                            {leadGroup.count_product_category} Categories
                                        </Grid>
                                        <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.totalClosing} Closing
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        leadGroup.byHours.map((lead, indexLeads) => {
                                            return (
                                                <Paper elevation={0} sx={{mb: "10px", padding: "5px"}} key={`itemleads-${indexLeads}`}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={9}>
                                                            <Typography component="span">{lead.label}</Typography>
                                                        </Grid>
                                                        <Grid item xs={3} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.count}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                </Paper>
                                            );
                                        })
                                    }
                                    
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                    }
                
                {
                    !Global.isMitraPrestisa() && (
                        <Paper sx={{mt: "20px", padding: "5px"}}>
                            <Typography variant='h6' component={"div"}>
                                Leads By Product Categories By Time Sections
                            </Typography>
                            {
                                this.props.contactLeadsHourly?.map((leadGroup, index) => {
                                return (
                                    <Accordion key={`key-by-shift-${index}`}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMore />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <Grid container spacing={1}>
                                                <Grid item xs={6}>
                                                    <Typography variant='h6' component="span">{leadGroup.label}</Typography>
                                                </Grid>
                                                <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                    <Typography variant='h6' component="span">
                                                        {leadGroup.timeSection}
                                                    </Typography>
                                                </Grid>
                                                {/* <Grid item xs={6} textAlign={"left"} sx={{pr: "5px"}}>
                                                    {leadGroup.count_product_category} Categories
                                                </Grid>
                                                <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                    {leadGroup.totalClosing} Closing
                                                </Grid> */}
                                            </Grid>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Paper elevation={0} sx={{mb: "10px", padding: "5px"}} key={`itemleads`}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={9}>
                                                        <Typography component="span">Leads Papan</Typography>
                                                    </Grid>
                                                    <Grid item xs={3} textAlign={"right"} sx={{pr: "5px"}}>
                                                        {leadGroup.countLeadsPapan}
                                                    </Grid>
                                                </Grid>
                                                <Divider />
                                                <Grid container spacing={1}>
                                                    <Grid item xs={9}>
                                                        <Typography component="span">Leads Non Papan</Typography>
                                                    </Grid>
                                                    <Grid item xs={3} textAlign={"right"} sx={{pr: "5px"}}>
                                                        {leadGroup.countLeadsNonPapan}
                                                    </Grid>
                                                </Grid>
                                                <Divider />
                                                <Grid container spacing={1}>
                                                    <Grid item xs={9}>
                                                        <Typography component="span">CR Leads Papan</Typography>
                                                    </Grid>
                                                    <Grid item xs={3} textAlign={"right"} sx={{pr: "5px"}}>
                                                        {leadGroup.countLeadsPapan > 0 ? (leadGroup.countClosingPapan/leadGroup.countLeadsPapan*100).toFixed(1).replace(".0", "") : 0}%
                                                    </Grid>
                                                </Grid>
                                                <Divider />
                                                <Grid container spacing={1}>
                                                    <Grid item xs={9}>
                                                        <Typography component="span">CR Leads Non Papan</Typography>
                                                    </Grid>
                                                    <Grid item xs={3} textAlign={"right"} sx={{pr: "5px"}}>
                                                        {leadGroup.countLeadsNonPapan > 0 ? (leadGroup.countClosingNonPapan/leadGroup.countLeadsNonPapan*100).toFixed(1).replace(".0", "") : 0}%
                                                    </Grid>
                                                </Grid>
                                                <Divider />
                                            </Paper>
                                        </AccordionDetails>
                                    </Accordion>
                                );
                            })
                            }
                        </Paper>
                    )
                }

                <Paper sx={{mt: "20px", padding: "5px"}}>
                    <Typography variant='h6' component={"div"}>
                        Closing By product Categories
                    </Typography>
                    {
                        this.props.closingByProductCategory?.map((leadGroup, index) => {
                        return (
                            <Box key={`closing-${index}`}>
                                <Grid container spacing={1}>
                                    <Grid item xs={8}>
                                        <strong>{leadGroup.product_category}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"} sx={{pr: "5px"}}>
                                        <strong>
                                            CR : {leadGroup.leads_count > 0 ? (leadGroup.closing_count/leadGroup.leads_count*100).toFixed(2).replace(".00", "") : 0}%
                                        </strong>
                                    </Grid>
                                    <Grid item xs={8}>
                                        {leadGroup.leads_count} leads
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"} sx={{pr: "5px"}}>
                                        {leadGroup.closing_count} closing
                                    </Grid>
                                </Grid>
                                <Divider sx={{mt: "5px", mb: "5px"}} />
                            </Box>
                        );
                    })
                    }
                </Paper>

                </Box>
            </Box>
        );
    }
}
 
export default SoldProductCategoryMobile;